<div class="px-4 py-4">
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element" data-label="Name">
        {{ element.name }}
      </td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let element" data-label="Description">
        {{ element.description ?? '--' }}
      </td>
    </ng-container>

    <!-- Is Active Column -->
    <ng-container matColumnDef="is_active">
      <th mat-header-cell *matHeaderCellDef>Is Active</th>
      <td mat-cell *matCellDef="let element" data-label="Is Active">
        {{ element.is_active }}
      </td>
    </ng-container>

    <!-- Created At Column -->
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>Created At</th>
      <td mat-cell *matCellDef="let element" data-label="Created At">
        {{ element.created_at | date: 'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <ng-container *appHasAccess="'edit-master-transaction-setting'">
          Action
        </ng-container>
      </th>
      <td mat-cell *matCellDef="let element" data-label="Action">
        <div class="d-flex align-items-center action-gap-10">
          <img
            src="assets/images/edit-icon.svg"
            alt="edit-icon"
            matTooltip="Edit"
            matTooltipPosition="left"
            [attr.aria-hidden]="true"
            (click)="onEdit(element)"
            *appHasAccess="'edit-master-transaction-setting'" />
          <img
            src="assets/images/delete-icon.svg"
            alt="delete-icon"
            matTooltip="Delete"
            matTooltipPosition="right"
            [attr.aria-hidden]="true"
            (click)="onDelete(element)"
            *appHasAccess="'delete-master-transaction-setting'" />
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      class="custom-mat-btn"
      *matRowDef="let row; columns: displayedColumns; let element"></tr>
  </table>
</div>
